import React, { PureComponent, Fragment } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import './iframe.scss'

class IFrame extends PureComponent {
	state = {
		isLoading: true,
	}

	onLoad = () => {
		this.setState({ isLoading: false })
	}

	render() {
		const {
			className,
			height,
			width,
			title,
			src,
			children,
			...rest
		} = this.props

		const { isLoading } = this.state

		const iFrameClass = 'c-iframe'
		const cssClasses = classNames(
			iFrameClass,
			{ 'is-loading': isLoading },
			className
		)

		return (
			<Fragment>
				<iframe
					width={width}
					title={title}
					height={height}
					scrolling="no"
					src={src}
					frameBorder="no"
					allowFullScreen
					style={{ height, width }}
					className={cssClasses}
					onLoad={() => {
						this.onLoad()
					}}
					{...rest}
				>
					{children}
				</iframe>

				{isLoading && (
					<div className={`${iFrameClass}__loading`}>
						<span>Loading...</span>
					</div>
				)}
			</Fragment>
		)
	}
}

IFrame.propTypes = {
	className: PropTypes.string,
	children: PropTypes.node,
	height: PropTypes.string,
	width: PropTypes.string,
	src: PropTypes.string.isRequired,
	title: PropTypes.string,
}

IFrame.defaultProps = {
	className: null,
	children: null,
	height: null,
	width: null,
	title: null,
}

export default IFrame
